import { render } from "./accordion-section.vue?vue&type=template&id=73d9d8c8"
import script from "./accordion-section.vue?vue&type=script&lang=js"
export * from "./accordion-section.vue?vue&type=script&lang=js"

import "./accordion-section.vue?vue&type=style&index=0&id=73d9d8c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__